import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'store/configureStore';
import { reportingOp } from 'store/ducks/Reportings';
import { TitleList } from 'store/ducks/globalTypes';
import { set_selectedDate } from 'store/ducks/Reportings/reportingSlice';
import { buildEntityToFunctionReverseTree } from './EntityToFunctionReverseTreeBuilder';
import HierarchicalTreePage from '../HierarchicalTreePage';
import { entityOp } from 'store/ducks/DataEntry/Entities';
import { useTranslation } from 'react-i18next';

const EntityToFunctionReverseTree: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const { date } = useSelector((state: RootState) => state.reportings);
  const { t } = useTranslation();
  const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [entityOptions, setEntityOptions] = useState<
    { value: number; label: string }[]
  >([]);

  useEffect(() => {
    const fetchEntities = async () => {
      try {
        const res = await entityOp.fetchEntityNames();

        setEntityOptions(
          (res?.data || []).map((e: any) => ({
            value: e.id,
            label: e.name_of_entity,
          })),
        );
      } catch (err) {
        console.error('Entity fetch error:', err);
      }
    };

    fetchEntities();
  }, []);

  useEffect(() => {
    if (selectedEntityId == null) return;

    const fetchData = async () => {
      try {
        const res = await reportingOp.filterEnityToFunctionReverse(
          selectedEntityId,
          date,
        );
        const apiData = res?.data ?? res ?? [];

        setData(apiData);
      } catch (err) {
        console.error('Tree fetch error:', err);
        setData([]);
      }
    };

    fetchData();
  }, [selectedEntityId, date]);
  return (
    <HierarchicalTreePage
      title={t(TitleList.ENTITYTOFUNCTIONREVERSE)}
      data={Array.isArray(data) ? data : [data]}
      entityOptions={entityOptions}
      selectedEntityId={selectedEntityId}
      setSelectedEntityId={setSelectedEntityId}
      onDateChange={(dateString) => {
        dispatch(set_selectedDate(dateString));
      }}
      buildTree={buildEntityToFunctionReverseTree}
    />
  );
};

export default EntityToFunctionReverseTree;
